import Mutations from '../../odata/mutations';

export default { ...new Mutations('userPin'), ...new Mutations('userPins') };
